module.exports = __webpack_public_path__ + "static/media/done_active.20aa58e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/done_active.svg
// module id = 468
// module chunks = 0